import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { Publication } from '../../../../models/publication.interface';
import { publicationsService } from '../../../../services/publications.service';

export function PublicationsSection() {
    const { lang, t } = useLanguage();
    const [publications, setPublications] = useState<Publication[]>([]);

    useEffect(() => {
        setPublications(publicationsService.getPublications());
    }, []);

    return (
        <SectionWrapper id="publications" title={t('section.publications')}>
            <div className="space-y-4">
                {publications.map(pub => (
                    <div key={pub.id} className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm ring-1 ring-slate-900/5 dark:ring-slate-700/50">
                        <div className="flex items-start gap-3">
                            <div className="shrink-0 mt-1 w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                                <i className="bi bi-journal-text text-blue-600 dark:text-blue-400 text-sm" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-slate-900 dark:text-white">
                                    {pub.url ? (
                                        <a href={pub.url} target="_blank" rel="noreferrer noopener" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                                            {pub.title[lang]}
                                            <i className="bi bi-box-arrow-up-right ml-2 text-xs" />
                                        </a>
                                    ) : pub.title[lang]}
                                </h3>
                                <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                                    {pub.venue} &middot; {pub.year}
                                </p>
                                <p className="text-sm text-slate-600 dark:text-slate-300 mt-2">
                                    {pub.description[lang]}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
